module.exports = __webpack_public_path__ + "img/upgrade-rounded.57d7155c.svg";